import React from "react";
import { App } from "./components/App";
import ReactDOM from "react-dom/client";

const root = ReactDOM.createRoot(
  document.getElementById("root")
);
root.render(<App />);
